import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { SolutionSection } from './components/SolutionSection';
import { ProductContent } from './components/ProductContent';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { TestimonialsSection } from './components/TestimonialsSection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const f = window as any;
    if (f.fbq) return;
    const n = (f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    }) as any;
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '841702842124464');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-emerald-500/30 selection:text-emerald-200" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main className="flex flex-col" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPoints data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <ProductContent data-id="element-6" />

        <BonusSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <GuaranteeSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <FinalCTA data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <SocialProofPopup data-id="element-14" />
    </div>;
}